export default "__VITE_ASSET__Dmq6gL8O__"